// Browser storage can be blocked; preferences must never prevent app startup.
export function readPreference(key: string): string | null {
  try { return localStorage.getItem(key); }
  catch { return null; } // A denied preference is intentionally treated as unset.
}

export function writePreference(key: string, value: string): void {
  try { localStorage.setItem(key, value); }
  catch { console.warn('Browser storage is unavailable; preferences will last for this session only.'); }
}